import { Box, Table, Tr, Th, Text, Thead, Tbody, Td } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { prettyPrintFormula } from '@finley-technologies/calc-agent';
import { utils as commonUtils } from '@finley-technologies/common';

import { getIterationKey } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

type LoanProductIntermediateCalcProps = {
  intermediateCalc: {
    field: string;
    config:
      | { formula: string; method: never }
      | { method: string; formula: never };
  };
};
export const LoanProductIntermediateCalc = ({
  intermediateCalc,
}: LoanProductIntermediateCalcProps) => {
  return (
    <Tr>
      <Td>{intermediateCalc.field}</Td>
      <Td whiteSpace="pre-wrap">
        {intermediateCalc.config.formula ? (
          <Text>
            {prettyPrintFormula(String(intermediateCalc.config.formula))}
          </Text>
        ) : (
          <Text>
            {commonUtils.toSentenceCase(intermediateCalc.config.method)}
          </Text>
        )}
      </Td>
    </Tr>
  );
};

type LoanProductIntermediateCalcsProps = {
  intermediateCalcs: {
    field: string;
    config: { formula: string } | { method: string };
  }[];
};
export const LoanProductIntermediateCalcs = ({
  intermediateCalcs,
}: LoanProductIntermediateCalcsProps) => {
  return (
    <>
      <Box mb="35px" width="100%">
        <Text fontWeight="bold" fontSize="18px">
          Intermediate Calculations
        </Text>

        {intermediateCalcs.length === 0 && (
          <Text>
            There are currently no intermediate calcs for this loan product.
          </Text>
        )}
        {intermediateCalcs.length > 0 && (
          <Table borderWidth="1px">
            <Thead>
              <Tr>
                <Th>Field Name</Th>
                <Th>Value</Th>
              </Tr>
            </Thead>
            <Tbody>
              {_.map(intermediateCalcs, (intermediateCalc: any) => {
                const id = getIterationKey(intermediateCalc);
                return (
                  <LoanProductIntermediateCalc
                    intermediateCalc={intermediateCalc}
                    key={id}
                  />
                );
              })}
            </Tbody>
          </Table>
        )}
      </Box>
    </>
  );
};
